<template>
  <div class="global-header" :class='[`global-header--${setting.navTheme}`,`global-header--${setting.layout}`]'>

    <ut-dropdown>
      <div class="user-info tool">
        <div class="avatar">
          <img :src="userInfo.avatar" alt="avatar">
        </div>
        <span>{{userInfo.userName}}</span>
      </div>
      <template slot='dropdown'>
        <!-- <ut-dropdown-item class='user-info-nav' @click.native='goTo(item.path)' v-for='item in userInfo.list' :key='item.title'>{{item.title}}</ut-dropdown-item> -->
        <ut-dropdown-item class='user-info-nav' divided @click.native='loginOut'>退出登录</ut-dropdown-item>
      </template>
    </ut-dropdown>
  </div>
</template>

<script>
// import NoticeIcon from './NoticeIcon'
// import NoticeIconTab from './NoticeIconTab'
import setting from '@/defaultSetting'
import { instance } from '@/assets/js/keycloak.js'

export default {
  name: 'globalHeader',
  props: {
    // userInfo: Object,
    navIcon: Object
  },
  components: {
    // NoticeIcon,
    // NoticeIconTab
  },
  computed: {
    userInfo () {
      const info = instance.idTokenParsed
      const id = parseInt(info.sub.split('-')[0], 16)
      const avatar = `https://image.supamob.com.cn/imageView2/reading-platform/avatar/default_${(id % 99).toString().padStart(2, '0')}_50x50_@3x.png`

      return {
        avatar,
        userName: info.preferred_username
      }
    }
  },
  data () {
    return {
      setting
    }
  },
  methods: {
    goTo (path) {
      this.$router.push(path)
    },
    clear (idx) {
      this.$emit('clear', idx)
    },
    itemClick (item, idx) {
      this.$emit('item-click', item, idx)
    },
    loginOut () {
      instance.logout()
      // this.$http({
      //   method: 'get',
      //   url: 'logout.htm',
      //   data: '{}'
      // })
      //   .then(response => {
      //     // 这里使用了ES6的语法
      //     console.log('login response ')
      //     console.log(response) // 请求成功返回的数据
      //     if (response.data.code == 0) {
      //       this.$router.push('login')
      //     } else {
      //       this.$message.error(response.data.message)
      //     }
      //   })
      //   .catch(error => {
      //     console.log(error) // 请求失败返回的数据
      //   })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
.global-header {
  display: flex;
  justify-content: flex-end;
  &--dark&--topMenu {
    color: #fff;
    .tool:hover {
      background: #1890ff;
    }
  }
}
.avatar {
  display: flex;
  align-items: center;
  margin-right: 8px;
  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: 1px solid #eee;
  }
}
.tool {
  width: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover {
    background: #d9ecff;
  }
}
.user-info {
  width: auto;
  padding: 0 16px;
  font-size: 14px;
}
.user-info-nav {
  font-size: 13px;
}
</style>
